// Internal module — consumers should import from './metrics' (barrel) instead.
import colors from '../../../styles/colors';
import { MetricKey } from '../model/WeeklyStatisticsResponse';

export type { MetricKey };

export interface MetricConfig {
  key: MetricKey;
  translationKey: string;
  color: string;
}

export const METRICS: MetricConfig[] = [
  {
    key: 'registrations',
    translationKey: 'monitoring_tile_registrations',
    color: colors.blue[500],
  },
  {
    key: 'paymentMethodsAdded',
    translationKey: 'monitoring_tile_payment_methods',
    color: colors.green[400],
  },
  {
    key: 'borrows',
    translationKey: 'monitoring_tile_borrows',
    color: colors.purple[500],
  },
  {
    key: 'returns',
    translationKey: 'monitoring_tile_returns',
    color: colors.pink[500],
  },
  {
    key: 'paid',
    translationKey: 'monitoring_tile_paid',
    color: colors.orange[500],
  },
];

export const METRIC_BY_KEY = Object.fromEntries(METRICS.map((m) => [m.key, m])) as Record<MetricKey, MetricConfig>;
